import React from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";
import { formatDateTransactionDetail } from "../../../helper/formatDate";
import { Table } from "../../../components/ui";
import { formatRupiah } from "../../../helper/formatNumber";

export function ModalReturDetail({ isShowModal, returDetail, onClose }) {
  return createPortal(
    isShowModal && (
      <div className="modal-product-container">
        <div className="modal-product-content">
          <header className="modal-product-header">
            <h2 className="modal-product-header-title">Detail Transaksi</h2>
            <button type="button" className="modal-header-close-button" onClick={() => onClose()}>
              <FaTimes size={20} />
            </button>
          </header>
          <main className="modal-product-main">
            <div className="mb-4">
              <p className="mt-0 mb-2">Tanggal Transaksi: {formatDateTransactionDetail(returDetail.product_transaction_date)}</p>
              <p className="mt-0 mb-2">Tanggal Retur: {formatDateTransactionDetail(returDetail.transaction_refund_date)}</p>
              <p className="mt-0 mb-2">Pasien: {returDetail.patient_name ? returDetail.patient_name : "-"}</p>
              <p className="mt-0 mb-2">Dokter: {returDetail.doctor_name ? returDetail.doctor_name : "-"}</p>
              <p className="mt-0 mb-2">Staff: {returDetail.staff_name}</p>
            </div>
          </main>

          <Table>
            <thead>
              <tr>
                <th style={{ width: "50px" }}>No</th>
                <th>Obat</th>
                <th>Jumlah</th>
                <th>Harga Satuan</th>
                <th>Total Transaksi</th>
              </tr>
            </thead>
            <tbody>
              {returDetail.product_transaction_data.map((transaction, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{transaction.product_transaction_name}</td>
                  <td>{transaction.product_transaction_quantity}</td>
                  <td>{formatRupiah(transaction.product_transaction_per_item_price)}</td>
                  <td>{formatRupiah(transaction.product_transaction_price)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    ),
    document.getElementById("modal")
  )
}
